import { z } from "zod";
import {
  JobDepartmentSchema,
  createJobDepartmentSchema,
  updateJobDepartmentSchema,
} from "@/lib/validations/business/job-department";

/** Fields that can be edited in a job department */
export type JobDepartmentEditableField =
  | "name"
  | "code"
  | "description"
  | "parent_department_id";

/** Interface defining permissions for job department fields */
export interface JobDepartmentFieldPermissions {
  editable: JobDepartmentEditableField[];
  viewable: JobDepartmentEditableField[];
}

/** Fields that can be used for sorting job departments */
export const JobDepartmentSortable = [
  "name",
  "code",
  "created",
  "updated",
] as const;
export type JobDepartmentSortField = (typeof JobDepartmentSortable)[number];

/** Complete job department type with all fields */
export type JobDepartment = z.infer<typeof JobDepartmentSchema>;

/** Job department with relationships */
export interface JobDepartmentWithRelations extends JobDepartment {
  parentDepartment?: JobDepartment | null;
  childDepartments?: JobDepartment[];
  jobs?: Array<{
    id: string;
    title: string;
  }>;
}

/** Type for creating a new job department */
export type CreateJobDepartmentInput = z.infer<
  typeof createJobDepartmentSchema
>;

/** Type for updating an existing job department */
export type UpdateJobDepartmentInput = z.infer<
  typeof updateJobDepartmentSchema
>;

/** Simple job department type for lists */
export interface SimpleJobDepartment {
  id: string;
  name: string;
  code: string;
}
